/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */
const INTERNAL_SERVER_ERROR_ENDPOINT_WHITELIST = [{
    url: 'distribution/api/ui/security/effective_permissions',
    error: '#httpStatus - Error occurred while fetching Distribution effective permissions'
},{
    url: 'ui/onboarding/createDefaultRepos',
    error: '#httpStatus - Error occurred while attempting to create repository. \n See Artifactory logs for details.'
}];

export function artifactoryServerErrorInterceptor($injector) {
    var $state;
    var $q;
    var AppContext;

    function initInjectables() {
        $q = $q || $injector.get('$q');
        $state = $state || $injector.get('$state');
        AppContext = AppContext || $injector.get('AppContext');
    }

    function responseError(res) {
        initInjectables();
        if (res.status <= 0 && res.xhrStatus !== 'abort') {
            window.$vueRouter.push({name:'500'})
        }

        if(res.status >= 500) {
            const isDistributionMcPairingRequired = res.status === 503
                && res.data.errors
                && res.data.errors.find(({ code }) => code === 'pairing.required');
            if(isDistributionMcPairingRequired) {
                AppContext.setPairingStatus(false);
                return $q.reject(res);
            }
            const whiteListedEndpoint = INTERNAL_SERVER_ERROR_ENDPOINT_WHITELIST
                    .find(({ url }) => res.config.url.includes(url));
            if (whiteListedEndpoint) {
                const error = whiteListedEndpoint.error.replace(/#httpStatus/g, res.status);
                window.store.dispatch('CREATE_NOTIFICATION', {
                    error
                });
                return $q.reject(res);
            }
            window.$vueRouter.push({name:'500'})
        }
        return $q.reject(res);
    }

    return {
        responseError: responseError
    };
}




// WEBPACK FOOTER //
// ./services/artifactory_server_error_interceptor.js